"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[906],{

/***/ 530906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WhatsaapFloatingIcon; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/isMobileDevice.ts
var isMobileDevice = __webpack_require__(826910);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/WhatsaapFloatingIcon/utils.tsx

function getSvg(type) {
    switch(type){
        case "type1":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 22 22",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        id: "Digital_Glyph_Black 2",
                        "clip-path": "url(#clip0_21_98)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector",
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M18.6906 3.19459C16.6342 1.13555 13.8993 0.00104467 10.9852 0C4.98045 0 0.0934976 4.88643 0.0914082 10.8927C0.0903635 12.8128 0.592326 14.6869 1.54559 16.3386L0 21.984L5.77491 20.4692C7.36593 21.3373 9.15753 21.7943 10.9805 21.7949H10.9852C16.9889 21.7949 21.8764 16.9079 21.8785 10.9016C21.8795 7.99068 20.7476 5.25415 18.6906 3.19511V3.19459ZM10.9852 19.9552H10.9815C9.35705 19.9547 7.76345 19.518 6.37301 18.6933L6.04235 18.4969L2.61533 19.3958L3.52993 16.0544L3.31473 15.7118C2.40848 14.2702 1.9295 12.6039 1.93054 10.8933C1.93263 5.90132 5.99429 1.83966 10.9889 1.83966C13.4072 1.8407 15.6805 2.78352 17.39 4.4952C19.0996 6.20637 20.0404 8.48167 20.0393 10.9006C20.0372 15.8931 15.9756 19.9547 10.9852 19.9547V19.9552ZM15.9515 13.1743C15.6794 13.038 14.3412 12.3798 14.0915 12.2889C13.8418 12.198 13.6606 12.1526 13.4793 12.4253C13.2981 12.6979 12.7763 13.3112 12.6175 13.4924C12.4587 13.6742 12.2999 13.6966 12.0277 13.5603C11.7557 13.424 10.8786 13.1367 9.83868 12.2095C9.0296 11.4876 8.48319 10.5966 8.32445 10.3239C8.16565 10.0513 8.30773 9.90395 8.4435 9.76867C8.56572 9.64645 8.71565 9.45058 8.85196 9.29178C8.98834 9.13298 9.03325 9.01915 9.1241 8.83786C9.21502 8.65609 9.16956 8.49735 9.10168 8.36097C9.03373 8.22466 8.48951 6.88484 8.26228 6.34007C8.0413 5.80939 7.81675 5.88147 7.6501 5.8726C7.4913 5.86476 7.31008 5.86319 7.1283 5.86319C6.94653 5.86319 6.6519 5.9311 6.40224 6.20376C6.15259 6.47639 5.4495 7.13505 5.4495 8.47431C5.4495 9.81358 6.42473 11.1085 6.56104 11.2903C6.69736 11.472 8.48057 14.2211 11.2108 15.4005C11.8601 15.681 12.3673 15.8486 12.7627 15.974C13.4146 16.1814 14.0079 16.1521 14.477 16.0821C14.9999 16.0038 16.0873 15.4235 16.314 14.7878C16.5407 14.1521 16.5407 13.6068 16.4728 13.4934C16.4049 13.3801 16.2232 13.3116 15.951 13.1753L15.9515 13.1743Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "clip0_21_98",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "21.8785",
                                height: "22",
                                fill: "white"
                            })
                        })
                    })
                ]
            });
        case "type2":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 40 40",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        id: "Digital_Glyph_Black 1",
                        "clip-path": "url(#clip0_21_93)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector",
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M33.983 5.80834C30.2441 2.06464 25.2714 0.00189939 19.973 0C9.05536 0 0.169996 8.88442 0.166197 19.805C0.164297 23.296 1.07696 26.7035 2.81015 29.7065L0 39.9708L10.4998 37.2167C13.3926 38.7951 16.6501 39.6261 19.9645 39.6271H19.973C30.8888 39.6271 39.7752 30.7417 39.779 19.8211C39.7809 14.5285 37.7229 9.55301 33.983 5.80929V5.80834ZM19.973 36.2822H19.9664C17.0128 36.2813 14.1154 35.4873 11.5873 33.9877L10.9861 33.6307L4.75514 35.2651L6.41806 29.1898L6.02677 28.5668C4.37905 25.9457 3.50818 22.9161 3.51008 19.806C3.51388 10.7297 10.8987 3.34483 19.9798 3.34483C24.3768 3.34673 28.5099 5.06094 31.6182 8.17309C34.7266 11.2843 36.437 15.4212 36.4351 19.8192C36.4313 28.8965 29.0465 36.2813 19.973 36.2813V36.2822ZM29.0028 23.9533C28.508 23.7054 26.0749 22.5087 25.6209 22.3435C25.167 22.1782 24.8375 22.0957 24.5078 22.5914C24.1783 23.0872 23.2296 24.2021 22.9409 24.5316C22.6522 24.8621 22.3634 24.903 21.8686 24.655C21.3739 24.4072 19.7793 23.8849 17.8885 22.1991C16.4175 20.8866 15.424 19.2665 15.1354 18.7707C14.8466 18.275 15.105 18.0072 15.3518 17.7612C15.574 17.539 15.8466 17.1829 16.0945 16.8941C16.3424 16.6054 16.4241 16.3985 16.5893 16.0688C16.7546 15.7383 16.6719 15.4497 16.5485 15.2018C16.425 14.9539 15.4355 12.5179 15.0223 11.5274C14.6206 10.5625 14.2123 10.6936 13.9093 10.6774C13.6206 10.6632 13.291 10.6604 12.9606 10.6604C12.6301 10.6604 12.0944 10.7838 11.6404 11.2796C11.1865 11.7752 9.90819 12.9728 9.90819 15.4078C9.90819 17.8429 11.6813 20.1972 11.9292 20.5277C12.177 20.8582 15.4192 25.8565 20.3833 28.0009C21.5639 28.5108 22.486 28.8157 23.2049 29.0436C24.3902 29.4207 25.469 29.3675 26.3218 29.2402C27.2725 29.0978 29.2497 28.0427 29.6619 26.8868C30.074 25.731 30.074 24.7396 29.9506 24.5335C29.8272 24.3274 29.4967 24.203 29.0019 23.9551L29.0028 23.9533Z",
                            fill: "#111B21"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "clip0_21_93",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "39.779",
                                height: "40",
                                fill: "white"
                            })
                        })
                    })
                ]
            });
        case "type3":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 40 40",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        id: "Digital_Glyph_Green 1",
                        "clip-path": "url(#clip0_21_90)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector",
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M33.9168 5.80834C30.1852 2.06464 25.2221 0.00189939 19.9341 0C9.03771 0 0.169664 8.88442 0.165873 19.805C0.163977 23.296 1.07486 26.7035 2.80468 29.7065L0 39.9708L10.4794 37.2167C13.3665 38.7951 16.6176 39.6261 19.9256 39.6271H19.9341C30.8286 39.6271 39.6977 30.7417 39.7015 19.8211C39.7034 14.5285 37.6494 9.55301 33.9168 5.80929V5.80834ZM19.9341 36.2822H19.9275C16.9797 36.2813 14.0879 35.4873 11.5647 33.9877L10.9647 33.6307L4.74587 35.2651L6.40555 29.1898L6.01503 28.5669C4.37052 25.9457 3.50134 22.9161 3.50324 19.806C3.50703 10.7297 10.8775 3.34483 19.9408 3.34483C24.3293 3.34673 28.4544 5.06094 31.5566 8.17309C34.659 11.2843 36.366 15.4212 36.3641 19.8192C36.3603 28.8965 28.9899 36.2813 19.9341 36.2813V36.2822ZM28.9462 23.9533C28.4524 23.7054 26.0241 22.5087 25.571 22.3435C25.1179 22.1782 24.7891 22.0957 24.4601 22.5914C24.1312 23.0872 23.1843 24.2021 22.8962 24.5316C22.608 24.8621 22.3198 24.903 21.826 24.655C21.3323 24.4072 19.7408 23.8849 17.8537 22.1991C16.3855 20.8866 15.3939 19.2665 15.1059 18.7707C14.8177 18.275 15.0755 18.0072 15.3219 17.7612C15.5437 17.539 15.8158 17.1829 16.0631 16.8941C16.3106 16.6054 16.3921 16.3985 16.557 16.0688C16.7219 15.7383 16.6394 15.4497 16.5163 15.2018C16.393 14.9539 15.4054 12.5179 14.993 11.5274C14.5921 10.5625 14.1846 10.6936 13.8822 10.6774C13.594 10.6632 13.2652 10.6604 12.9353 10.6604C12.6054 10.6604 12.0708 10.7838 11.6178 11.2796C11.1647 11.7752 9.88888 12.9728 9.88888 15.4078C9.88888 17.8429 11.6586 20.1972 11.9059 20.5277C12.1533 20.8582 15.3892 25.8565 20.3436 28.0009C21.5218 28.5108 22.4422 28.8157 23.1596 29.0436C24.3426 29.4207 25.4193 29.3675 26.2705 29.2402C27.2193 29.0978 29.1927 28.0427 29.6041 26.8869C30.0154 25.7311 30.0154 24.7396 29.8922 24.5335C29.7691 24.3274 29.4392 24.203 28.9454 23.9551L28.9462 23.9533Z",
                            fill: "#25D366"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "clip0_21_90",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "39.7015",
                                height: "40",
                                fill: "white"
                            })
                        })
                    })
                ]
            });
    }
}

// EXTERNAL MODULE: ./src/utils/getWhatsAppRedirectionUrl.js
var getWhatsAppRedirectionUrl = __webpack_require__(230066);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/WhatsaapFloatingIcon/index.tsx







function WhatsappFloatingIcon(props) {
    var handleIconClick = function handleIconClick() {
        (0,getWhatsAppRedirectionUrl/* openWhatsAppLeadModal */.iM)();
    };
    var ref, ref1;
    var ref2 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref2.widgetContextState, widgets = _widgetContextState.widgets, isBuilder = _widgetContextState.isBuilder;
    var ref3 = (0,react.useState)(false), isFooterComp = ref3[0], setIsFooterComp = ref3[1];
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var ref4 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), activeFooterData = ref4.widgetContextState.activeFooterData;
    var isGoToTopEnable = activeFooterData === null || activeFooterData === void 0 ? void 0 : (ref = activeFooterData.footerPropsConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.footerConfig) === null || ref1 === void 0 ? void 0 : ref1.showGoToTop;
    var activeWidget = widgets === null || widgets === void 0 ? void 0 : widgets[props.id];
    var activeWidgetProps = activeWidget === null || activeWidget === void 0 ? void 0 : activeWidget.props;
    var widgetOptions = (0,_object_spread/* default */.Z)({}, props.widgetOptions, activeWidgetProps);
    // We have go to top icon in footer using intersection observer here when footer enter in viewport we slightly up the floating icon to prevent overlap
    (0,react.useEffect)(function() {
        // We have multiple wrappers in builder on top of footer tag for smooth interaction uses top wrapper id for intersection
        var footer = isBuilder ? document.getElementById("widget-Footer") : document.getElementById("footer");
        var observer;
        if (footer && isGoToTopEnable) {
            observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        setIsFooterComp(true);
                    } else {
                        setIsFooterComp(false);
                    }
                });
            }, {
                root: null,
                threshold: 0.2
            });
        }
        observer === null || observer === void 0 ? void 0 : observer.observe(footer);
        return function() {
            if (footer) {
                observer === null || observer === void 0 ? void 0 : observer.unobserve(footer);
            }
        };
    }, [
        isGoToTopEnable
    ]);
    var isVisible = widgetOptions.isVisible, iconType = widgetOptions.iconType, background = widgetOptions.background;
    return isVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleIconClick,
        style: {
            background: iconType === "type1" ? background : "white",
            boxShadow: "0px 2px 6px 0px #111C3629"
        },
        className: "tw-fixed ".concat(isBuilder ? isFooterComp ? "tw-bottom-[180px]" : "tw-bottom-[48px]" : isFooterComp ? isMobile ? "tw-bottom-[84px]" : "tw-bottom-[150px]" : "tw-bottom-[24px]", "\n      ").concat(isMobile ? "tw-right-[20px]" : isBuilder ? "tw-right-[52px]" : "tw-right-[40px]", "\n      tw-z-100  tw-z-[100] tw-flex tw-h-[48px] tw-w-[48px] tw-cursor-pointer tw-flex-col tw-items-center tw-justify-center tw-rounded-[50%]"),
        children: getSvg(iconType)
    }) : null;
}
/* harmony default export */ var WhatsaapFloatingIcon = (WhatsappFloatingIcon);


/***/ })

}]);